import { TextButton } from '@components/core-ui/form-elements/buttons/Button/variations/TextButton';

type TProps = {
  message: string;
  onRetry: () => void;
};

export const LoadError = ({ message, onRetry }: TProps) => (
  <div className="my-4 flex items-center gap-3 text-xs text-[var(--color-text-muted)]" role="alert">
    <span>{message}</span>
    <TextButton type="button" onClick={onRetry}>
      Retry
    </TextButton>
  </div>
);
